import 'intersection-observer';

const observer = new IntersectionObserver(processIntersectionEntries);
const refsThatNeedToLoad = [];
export const forceAnotherIntervalID = setInterval(forceAnotherIntersection, 300);

export function observeIntersection(ref) {
  observer.observe(ref);
  refsThatNeedToLoad.push(ref);
}

export function unobserveIntersection(ref) {
  observer.unobserve(ref);
  const i = refsThatNeedToLoad.indexOf(ref);
  if (i >= 0) {
    refsThatNeedToLoad.splice(i, 1);
  }
}

export function processIntersectionEntries(entries) {
  entries.forEach(entry => {
    const target = entry.target;
    if (entry.isIntersecting) {
      target.dispatchEvent(new CustomEvent('changeInView', {
        detail: {
          inView: entry.isIntersecting,
        },
      }));
      observer.unobserve(target);
    }
  });
}

export function forceAnotherIntersection() {
  if (refsThatNeedToLoad.length) {
    refsThatNeedToLoad[0].dispatchEvent(new CustomEvent('changeInView', {
      detail: {
        inView: true,
      },
    }));
    return true;
  }
  return false;
}

export function forceAllToIntersect() {
  refsThatNeedToLoad.forEach(refThatNeedsToLoad => {
    refThatNeedsToLoad.dispatchEvent(new CustomEvent('changeInView', {
      detail: {
        inView: true,
      },
    }));
  });
}
